import type { EventDiscountConfig } from './types';

export interface ResolvedUpgradeDiscount {
  gold: boolean;
  goldPct: number;
  ruby: boolean;
  rubyPct: number;
}

const DEFAULT_PCT = 30;

/**
 * 업그레이드 할인 config 를 골드/루비 표기값으로 정규화한다.
 *
 * 불변식: **골드·루비 할인 딱지는 상호 배타** — 절대 동시에 켜지지 않는다.
 * - 신규 필드(upgradeGold/Ruby)가 하나라도 있으면 신규 경로.
 * - 레거시 upgrade 단일 필드는 통화를 특정하지 못하므로 딱지를 붙이지 않는다(폴백 off).
 *   (실제 비용 할인은 마스터데이터에서 처리하고, 이 토글은 딱지 표시 전용이다.)
 * - 잘못된 발행으로 골드·루비가 동시에 true 면 어느 쪽이 진짜 할인인지 알 수 없으므로
 *   둘 다 끈다 — 할인 아닌 통화에 딱지가 붙는 사고를 원천 차단.
 */
export function normalizeUpgradeDiscount(
  raw: Partial<EventDiscountConfig> | undefined
): ResolvedUpgradeDiscount {
  const r = raw ?? {};
  const goldPct = typeof r.upgradeGoldPct === 'number' ? r.upgradeGoldPct : DEFAULT_PCT;
  const rubyPct = typeof r.upgradeRubyPct === 'number' ? r.upgradeRubyPct : DEFAULT_PCT;

  // 레거시 단일 필드는 통화 특정 불가 → 딱지 off (신규 필드만 딱지를 켠다).
  const hasNew = r.upgradeGold !== undefined || r.upgradeRuby !== undefined;
  let gold = hasNew && r.upgradeGold === true;
  let ruby = hasNew && r.upgradeRuby === true;

  // 상호 배타 가드: 둘 다 켜지면 오설정 → 둘 다 끈다.
  if (gold && ruby) {
    gold = false;
    ruby = false;
  }

  return { gold, goldPct, ruby, rubyPct };
}
